export default __webpack_public_path__ + "static/media/smallb.a27efaf1.png";